import { render, staticRenderFns } from "./ClassesAssigned.vue?vue&type=template&id=11fefe3c&scoped=true&"
import script from "./ClassesAssigned.vue?vue&type=script&lang=js&"
export * from "./ClassesAssigned.vue?vue&type=script&lang=js&"
import style0 from "./ClassesAssigned.vue?vue&type=style&index=0&id=11fefe3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fefe3c",
  null
  
)

export default component.exports